import { GridColumnProps } from '@progress/kendo-react-grid';
import React from 'react';

export const ColumnMenuContext = React.createContext({
    onColumnsChange: (_columns: GridColumnProps[]) => {},
    columns: [] as Array<GridColumnProps & { default?: boolean }>,
    columnsState: [] as GridColumnProps[]
});
